import { MERCHANT } from "constants/action-types";
import {
    IPurchaseOrderDoorGroup,
    ICreatePurchaseOrderDoorGroup,
    IUpdatePurchaseOrderDoorGroup,
} from "helpers/delivery-purchase-order";
import { FluxStandardAction as Action } from "flux-standard-action";

export type ListPurchaseOrderDoorGroupsRequestAction = Action<void, { merchantId: string }>;
export const listPurchaseOrderDoorGroupsRequest = (merchantId): ListPurchaseOrderDoorGroupsRequestAction => ({
    meta: { merchantId },
    payload: undefined,
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.LIST.REQUEST,
});

export type ListPurchaseOrderDoorGroupsCompleteAction = Action<
    IPurchaseOrderDoorGroup[] | Error,
    { merchantId: string }
>;
export const listPurchaseOrderDoorGroupsComplete = (
    purchaseOrderDoorGroups: IPurchaseOrderDoorGroup[],
    merchantId: string
): ListPurchaseOrderDoorGroupsCompleteAction => ({
    meta: { merchantId },
    payload: purchaseOrderDoorGroups,
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.LIST.COMPLETE,
});

export type CreatePurchaseOrderDoorGroupRequestAction = Action<
    {
        index: number;
        purchaseOrderDoorGroup: ICreatePurchaseOrderDoorGroup;
    },
    { merchantId: string }
>;
export const createPurchaseOrderDoorGroupRequest = (
    index: number,
    purchaseOrderDoorGroup: ICreatePurchaseOrderDoorGroup,
    merchantId: string
): CreatePurchaseOrderDoorGroupRequestAction => ({
    meta: { merchantId },
    payload: {
        index,
        purchaseOrderDoorGroup,
    },
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.CREATE.REQUEST,
});

export type CreatePurchaseOrderDoorGroupCompleteAction = Action<
    IPurchaseOrderDoorGroup[] | Error,
    { merchantId: string }
>;
export const createPurchaseOrderDoorGroupComplete = (
    payload: IPurchaseOrderDoorGroup[] | Error,
    merchantId: string
): CreatePurchaseOrderDoorGroupCompleteAction => ({
    meta: { merchantId },
    payload,
    error: payload instanceof Error,
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.CREATE.COMPLETE,
});

export type UpdatePurchaseOrderDoorGroupRequestAction = Action<
    {
        index: number;
        purchaseOrderDoorGroup: IUpdatePurchaseOrderDoorGroup;
    },
    { merchantId: string }
>;
export const updatePurchaseOrderDoorGroupRequest = (
    index: number,
    purchaseOrderDoorGroup: IUpdatePurchaseOrderDoorGroup,
    merchantId: string
): UpdatePurchaseOrderDoorGroupRequestAction => ({
    meta: { merchantId },
    payload: {
        index,
        purchaseOrderDoorGroup,
    },
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.UPDATE.REQUEST,
});

export type UpdatePurchaseOrderDoorGroupCompleteAction = Action<
    IPurchaseOrderDoorGroup[] | Error,
    { merchantId: string }
>;
export const updatePurchaseOrderDoorGroupComplete = (
    payload: IPurchaseOrderDoorGroup[] | Error,
    merchantId: string
): UpdatePurchaseOrderDoorGroupCompleteAction => ({
    meta: { merchantId },
    payload,
    error: payload instanceof Error,
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.UPDATE.COMPLETE,
});

export type SortPurchaseOrderDoorGroupRequestAction = Action<
    {
        index: number;
        destinationIndex: number;
    },
    { merchantId: string }
>;
export const sortPurchaseOrderDoorGroupRequest = (
    index: number,
    destinationIndex: number,
    merchantId: string
): SortPurchaseOrderDoorGroupRequestAction => ({
    meta: { merchantId },
    payload: { index, destinationIndex },
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.SORT.REQUEST,
});

export type SortPurchaseOrderDoorGroupCompleteAction = Action<Error | undefined, { merchantId: string }>;
export const sortPurchaseOrderDoorGroupComplete = (
    payload: Error | undefined,
    merchantId: string
): SortPurchaseOrderDoorGroupCompleteAction => ({
    meta: { merchantId },
    payload,
    error: payload instanceof Error,
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.SORT.COMPLETE,
});

export type RemovePurchaseOrderDoorGroupRequestAction = Action<
    {
        index: number;
    },
    { merchantId: string }
>;
export const removePurchaseOrderDoorGroupRequest = (
    index: number,
    merchantId: string
): RemovePurchaseOrderDoorGroupRequestAction => ({
    meta: { merchantId },
    payload: { index },
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.REMOVE.REQUEST,
});

export type RemovePurchaseOrderDoorGroupCompleteAction = Action<Error | undefined, { merchantId: string }>;
export const removePurchaseOrderDoorGroupComplete = (
    payload: Error | undefined,
    merchantId: string
): RemovePurchaseOrderDoorGroupCompleteAction => ({
    meta: { merchantId },
    payload,
    error: payload instanceof Error,
    type: MERCHANT.PURCHASE_ORDER_DOOR_GROUP.REMOVE.COMPLETE,
});
